import React from 'react';

function ChemquoteExportModalHeader() {
  return (
    <div className="exportModal__header">
      <h4>Export substances ChemQuote</h4>
    </div>
  );
}

export default ChemquoteExportModalHeader;
